export enum ActionEnum {
  Created = 'Created',
  Updated = 'Updated',
  Deleted = 'Deleted'
}